import React from 'react';
import AdminManageContainer from '@src/containers/AdminManage';

const Admin = () => <AdminManageContainer />;

export default Admin;
